import { UseGetAdvice } from './type';
import React, { useEffect, useState, useRef } from 'react';
import { COLUMN_FROM } from '../../../effects/consts';
import { Tag } from 'antd';
import { getOpenApiData } from '@/common/asset-apis/assetModel';

export const useGetAdvice: UseGetAdvice = ({ field, API, config, storeValue, columnFrom, onChange }) => {
  const { dispatchEvent, destroyEvent, taskInfo } = config.metaStore || {};
  const { isOpenAdvice, openApiUrl, adviceValue, adviceApiKeyList, apiType = 'get', adviceColumn } = field?.bizConfig || {};
  const apiRef = useRef({});
  const [adviceList, setAdviceList] = useState<any[]>([]);
  const [adviceTableColumn, setAdviceTableColumn] = useState<any[]>([]);
  const [apiParamsList, setapiParamsList] = useState({});

  const handleColumn = () => {
    const colorList = ['orange', 'red', 'blue', 'purple', 'gold', 'geekblue', 'green'];
    if (adviceColumn) {
      const columnList = adviceColumn.split(',');
      const targetTableColumns =
        columnList?.map((itemKey: string) => {
          const resColumn = {
            dataIndex: itemKey,
            title: '',
          };
          if (itemKey === 'tags') {
            resColumn.render = (text: any) => {
              if (text?.length > 0) {
                return (
                  <div style={{ display: 'flex' }}>
                    {
                      text?.map((item: string, index: number) => {
                        return <Tag color={colorList[index] || 'blue'}>{item}</Tag>;
                      })
                    }
                  </div>
                );
              } else {
                return '';
              }
            };
          }
          return resColumn;
        }) || [];
      targetTableColumns.unshift({
        dataIndex: 'index',
        title: '序号',
        render: (text: string, record: any, index: number) => {
          return index + 1;
        },
      });
      targetTableColumns.push({
        key: 'action',
        title: '',
        render: (text: string, record: any) => (
          <a
            onClick={() => {
              onChange(record?.[adviceValue]);
            }}
          >
            选择
          </a>
        ),
      });
      setAdviceTableColumn(targetTableColumns);
    }
  };

  useEffect(() => {
    if (!isOpenAdvice) {
      return;
    }
    handleColumn();
    let headData: Record<any, any> = {};
    if (storeValue) {
      Object.keys(storeValue).forEach((key: any) => {
        if (!Array.isArray(storeValue[key])) {
          headData = storeValue[key];
        }
      });
    }
    if (columnFrom === COLUMN_FROM.FORM) {
      adviceApiKeyList?.forEach((item: any) => {
        apiRef.current = { ...apiRef.current, [item.adviceApiKey]: headData?.[item.adviceApiValueModule] };
      });
    }

    const mainModuleCode = taskInfo?.modules?.find(
      (module: any) => module.moduleID === taskInfo?.mainModuleId,
    )?.handle;
    const idList: any[] = [];
    adviceApiKeyList?.forEach((item: any) => {
      const events = [{
        code: field.name,
        name: field.label,
        touchConfig: 'change',
        actionType: 'callback',
        moduleName: mainModuleCode,
        fieldName: item.adviceApiValueModule,
        rowIndex: config.rowIndex,
        fun: (value: any) => {
          apiRef.current = { ...apiRef.current, [item.adviceApiKey]: value };
          setapiParamsList({ ...apiRef.current, [item.adviceApiKey]: value });
        },
      }];
      const ids = dispatchEvent?.(events);
      idList.push(ids);
    });
    return () => {
      idList?.forEach((ids: any) => {
        destroyEvent?.(ids);
      });
    };
  }, []);

  useEffect(() => {
    if (!isOpenAdvice) {
      return;
    }
    const pass = adviceApiKeyList?.every((item: any) => apiRef.current[item.adviceApiKey]);
    if (pass) {
      getOpenApiData(API?.FetchAPI, apiType, openApiUrl, apiRef.current).then((res: any) => {
        setAdviceList(Array.isArray(res) ? (res || []) : []);
      });
    }
  }, [JSON.stringify(apiRef.current)]);

  return {
    adviceList,
    adviceTableColumn,
  };
};
